import { render, staticRenderFns } from "./AiRoutingAccessPanel.vue?vue&type=template&id=047f902e&scoped=true"
import script from "./AiRoutingAccessPanel.vue?vue&type=script&lang=js"
export * from "./AiRoutingAccessPanel.vue?vue&type=script&lang=js"
import style0 from "./AiRoutingAccessPanel.vue?vue&type=style&index=0&id=047f902e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f902e",
  null
  
)

export default component.exports